import { Typography } from '@remarkable/ark-web';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { useDeleteRequestToCancelEnterpriseSubscription } from 'src/api/queries/enterpriseSubscription';
import { Button, Modal, NotificationBox } from 'src/components';

export function AbortCancelEnterpriseSubscriptionModal({
  onSuccess,
}: {
  onSuccess: () => void;
}) {
  const abortRequestToCancelSubscription =
    useDeleteRequestToCancelEnterpriseSubscription();

  return (
    <Modal.Content className="flex flex-col gap-24">
      <Modal.Title asChild>
        <Typography variant="heading-lg">Keep subscription</Typography>
      </Modal.Title>
      <Modal.Description>
        Stop the cancellation process of your Connect for Business subscription.
      </Modal.Description>

      <div className="flex justify-center gap-16">
        <Modal.Close asChild>
          <Button
            variant="secondary"
            analytics={{
              text: 'Close',
              location: ComponentLocations.ENTERPRISE.BILLING_PAGE,
              action: 'close abort request to cancel subscription modal',
            }}
          >
            Close
          </Button>
        </Modal.Close>

        <Button
          variant="primary"
          onClick={() => {
            abortRequestToCancelSubscription.mutate(undefined, { onSuccess });
          }}
          loading={abortRequestToCancelSubscription.isPending}
          disabled={abortRequestToCancelSubscription.isPending}
          analytics={{
            text: 'Keep subscription',
            location: ComponentLocations.ENTERPRISE.BILLING_PAGE,
            action: 'abort request to cancel subscription',
          }}
        >
          Keep subscription
        </Button>
      </div>

      <NotificationBox error={abortRequestToCancelSubscription.error} />
    </Modal.Content>
  );
}
